/* eslint-disable new-cap */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines-per-function */
import React, { useState } from 'react';
import { Modal, IconButton, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseSharpIcon from '@material-ui/icons/CloseSharp';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ListaLogs } from '../../services/tabelaPrecoApi/index';
import * as moment from 'moment';

import './style.css';

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

const ModalLogEdicoes = props => {
    const { id } = props;
    const [open, setOpen] = React.useState(false);
    const [logsEdicao, setLogsEdicao] = useState([]);

    async function BuscaLogs() {
        ListaLogs(id)
            .then(resp => {
                setLogsEdicao(resp);
            })
            .catch(err => {
                console.error('erro', err);
            });
    }

    logsEdicao.sort((a, b) => new Date(b.dataUpdate) - new Date(a.dataUpdate));

    let buscarPlano;

    for (const i in logsEdicao) {
        const idPlano = logsEdicao[i];

        buscarPlano = idPlano.plano;
    }

    const handleOpen = () => {
        setOpen(true);
        BuscaLogs();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const carenciaPromocionalBody = rowData => (
        <>
            <span className="p-column-title">Carência c/ Promoção</span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.carencia_promocional)}
        </>
    );

    const carenciaBody = rowData => (
        <>
            <span className="p-column-title">Carencia s/ Promoção</span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.carencia)}
        </>
    );

    const novoBody = rowData => (
        <>
            <span className="p-column-title"> Novo </span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.novo)}
        </>
    );

    const trocaBody = rowData => (
        <>
            <span className="p-column-title"> Troca </span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.troca)}
        </>
    );

    const reabilitacaoBody = rowData => (
        <>
            <span className="p-column-title"> Reabilitação </span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.reabilitacao)}
        </>
    );

    const cremaçãoBody = rowData => (
        <>
            <span className="p-column-title"> Cremação </span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.cremacao)}
        </>
    );

    const usuarioBody = rowData => (
        <>
            <span className="p-column-title"> Editado por </span>
            {rowData['userAccessUpdated.AnalistaComercial.userUpdated']}
        </>
    );

    const dataBody = rowData => (
        <>
            <span className="p-column-title"> Data da edição </span>
            {moment(rowData.dataUpdate)
                .add(3, 'hours')
                .format('DD/MM/YYYY [às] HH:mm:ss')}
        </>
    );

    const body = (
        <div className="ModalStyle modalLogEdicoes">
            <IconButton
                className="fecharModal"
                variant="contained"
                size="small"
                onClick={handleClose}
            >
                <CloseSharpIcon />
            </IconButton>
            <Typography variant="h6" align="center" gutterBottom>
                Registro de Edições
            </Typography>
            <h3 style={{ color: '#000000' }}>
                Plano: <span style={{ color: '#373737' }}>{buscarPlano}</span>
            </h3>
            <br />
            <div className="dentroModalLog">
                <div className="datatable-responsive-demo">
                    <DataTable
                        className="p-datatable-responsive-demo"
                        value={logsEdicao}
                        rows={6}
                        paginator
                        emptyMessage="Nenhuma edição encontrada"
                    >
                        <Column
                            field="carencia_promocional"
                            header="Carência c/ Promoção"
                            body={carenciaPromocionalBody}
                        ></Column>
                        <Column
                            field="carencia"
                            header="Carência s/ promoção"
                            body={carenciaBody}
                        ></Column>
                        <Column 
                            field="novo"
                            header="Novo"
                            body={novoBody}>
                        </Column>
                        <Column
                            field="troca"
                            header="Troca"
                            body={trocaBody}>
                        </Column>
                        <Column
                            field="reabilitacao"
                            header="Reabilitação"
                            body={reabilitacaoBody}
                        ></Column>
                        <Column
                            field="cremacao"
                            header="Cremação"
                            body={cremaçãoBody}
                        ></Column>
                        <Column
                            field="userUpdated"
                            header="Editado por"
                            body={usuarioBody}
                        ></Column>
                        <Column
                            field="dataUpdate"
                            header="Data da edição"
                            body={dataBody}
                        ></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <IconButton
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleOpen}
            >
                <SearchIcon />
            </IconButton>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

export default ModalLogEdicoes;
